const getGoogleMapsLink = (latitud, longitud) =>
  `https://maps.google.com/maps?q=${latitud},${longitud}`;

export default getGoogleMapsLink;



// WEBPACK FOOTER //
// ./src/utilities/maps.js